<template>
  <FormSection
    class="app-icon-upload"
    :title="$t('APP.MEDIA.CHANGE_ICON')"
    :description="iconGuideMsg"
  >
    <Card v-loading="uploading">
      <DroppableImageSelector
        class="app-icon-upload__uploader"
        accept=".png,.jpg,.jpeg"
        :image="app.icon"
        @change="uploadAppIcon"
      />

      <div v-show="error" class="app-icon-upload__error-message text-alert">
        <i class="el-icon-warning" />
        {{ error }}
      </div>
    </Card>
  </FormSection>
</template>

<script>
import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import DroppableImageSelector from '@@/common/file-selectors/DroppableImageSelector';

import { Apps } from '@/api/api';
import { mapMutations, mapGetters } from 'vuex';
import { APP_DETAILS } from '@/store/types';

import getFormData from '@/utils/getFormData';
import packageName from '@/mixins/packageName';

export default {
  name: 'AppIconUpload',
  components: { FormSection, Card, DroppableImageSelector },
  mixins: [packageName],

  data() {
    return {
      uploading: false,
      error: '',
    };
  },

  computed: {
    ...mapGetters({ app: APP_DETAILS }),
    iconGuideMsg() {
      const docsLink = `
        <a class="link" href="http://developers.cafebazaar.ir/fa/guidelines/icon-design/" target="_blank">
          ${this.$t('DOCUMENTATION')}
        </a>
      `;
      const imageLimits = `
        <ul class="image-limits text-latin">
          <li>${this.$t('APP.MEDIA.MIN_SIZE')}: 512px * 512px</li>
          <li>${this.$t('APP.MEDIA.MAX_SIZE')}: 3000px * 3000px</li>
          <li>${this.$t('APP.MEDIA.MAX_FILE_SIZE')}: 3MB</li>
          <li>${this.$t('APP.MEDIA.FILE_TYPE')}: PNG</li>
        </ul>
      `;
      return this.$t('APP.MEDIA.CHANGE_ICON_DESC', {
        docs: docsLink,
        imageLimits,
      });
    },
  },

  methods: {
    ...mapMutations({ updateAppDetails: APP_DETAILS }),
    selectFile() {
      this.$refs.fileInput.click();
    },
    uploadAppIcon(file) {
      if (!file) return false;

      this.error = '';
      this.uploading = true;
      const formData = getFormData([file], 'file');

      return Apps.uploadIcon({ packageName: this.packageName }, formData)
        .then(({ body: { icon, message } }) => {
          this.$message.success(message);
          this.updateAppDetails({ ...this.app, icon });
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
            this.error = message;
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.app-icon-upload {
  &__uploader {
    height: rem-calc(290px);

    @include breakpoint(medium down) {
      height: rem-calc(200px);
    }
  }

  &__error-message {
    margin-top: $global-margin;
    font-size: $lb-small-font-size;
  }

  .image-limits {
    margin-top: $global-margin * 2;
    list-style-position: inside;
    color: #555;
    font-size: 0.9rem;
  }
}
</style>
